export default __webpack_public_path__ + "f0918cac3406adee35aa2ff059911937.png";